// src/campaigns/configs/campaigns.2028.ts

import { buildCampaignsForYear } from "./campaign-factory";

export const campaigns2028 = buildCampaignsForYear(2028);
